import CurrencyAutoFillSection from './CurrencyAutoFillSection';

export default CurrencyAutoFillSection;
